import { Injectable } from '@angular/core';
import { ClientRulesService } from 'formbird-services';

@Injectable({
  providedIn: 'root'
})
export class UtilSharingService {

  constructor(private clientRulesService: ClientRulesService) { }

      // Function that would trigger/call functions from one component to other components/ rules
    //  componentFieldName=>name of component that contains the function;functionName=> name of the function declared in componentFieldName
    // e.g component function call:scope.sclUtilSharing.fnCallFunction(scope.fieldName,'eventReloadDatatable');
    // e.g rules calling: UtilSharingLibrary.fnCallFunction('scDatatablesTest','eventReloadDatatable');
    fnCallFunction(componentFieldName: string, functionName: string, param1: any, param2: any): any {
      this.clientRulesService.setSharedValue(functionName, {fieldName: componentFieldName, param1, param2, time: new Date()});
      if (/get/.test(functionName.slice(0, 3))) {
        const objectData = this.clientRulesService.getSharedValue(functionName.replace(/^get/, 'set'));
        let objectDataReturn = [];
        if (objectData) {
          if (objectData.param1 && objectData.param2) {
             objectDataReturn.push(objectData.param1, objectData.param2);
          } else if (objectData.param1) {
             objectDataReturn = objectData.param1;
          } else {
             objectDataReturn = objectData;
          }
          return objectDataReturn;
         }
      }

   }

   // Function that would register a list of function to call in fnCallFunction
   // listOfFunctions=>['eventReloadDatatable','eventReloadTable','function1','...']
   // list of functions that will be available  in fnCallFunction to be called.
fnRegisterFunctions(listOfFunctions) {
      for (let i = 0, n = listOfFunctions.length; i < n; i++) {
          this.fnCreateWatchForFunctionCall(listOfFunctions[i]);
      }
   }

fnCreateWatchForFunctionCall(functionName) {
    console.log('--------TODO implment watch in UtilSharingService');
    //  scope.$watch(function() {return this.clientRulesService.getSharedValue(functionName); }, function(objValue) {
    //   if (objValue) {
    //      // logger.info(functionName," is watch",objValue,objValue.fieldName,scope.fieldName);
    //      if (scope.fieldName === objValue.fieldName) {

    //       let variableFunction = 'scope.'+ functionName;
    //       let fn = eval('(' + variableFunction + ')');
    //       // logger.info(objValue.fieldName,scope.fieldName,variableFunction,fn);
    //       if (objValue.param1 && objValue.param2) {
    //         // variableFunction = "scope."+functionName+"('"+objValue.param1+"','"+objValue.param2+"')";
    //         fn(objValue.param1, objValue.param2);
    //       } else if (objValue.param1) {
    //          // variableFunction = "scope."+functionName+"('"+objValue.param1+"')";
    //          fn(objValue.param1);
    //       } else {
    //           fn();
    //       }



    //       // eval("(" + variableFunction + ")");
    //      }
    //    }
    //  }, true);
    //  let tempName = functionName;
    //  let firstThree = tempName.slice(0, 3);
    //  if (/set/.test(firstThree)) {
    //   let newStr = tempName.replace(firstThree,'');
    //   newStr = newStr.substr(0, 1).toLowerCase() + newStr.substr(1, newStr.length - 1);
    //   scope.$watch(newStr, function(objValue) {
    //      if (objValue) {
    //       logger.info(newStr,' is modified', objValue);
    //       ClientRulesService.setSharedValue(functionName, {fieldName: scope.fieldName, param1: objValue, time: new Date()});
    //      }
    //    }, true);
    //  }
   }

fnPassedDataObject(fieldName, objectName, objectDataValue) {
     this.clientRulesService.setSharedValue(objectName, {fieldName, objectDataValue, time: new Date().getTime()});
   }
fnGetDataObject(fieldName, objectName) {
     const objectData = this.clientRulesService.getSharedValue(objectName);
     return  objectData.fieldName === fieldName ? objectData : null ;
   }
}
